import { Route, Switch } from "react-router-dom";
import Router from "common/helpers/router";
import ForgotPassword from "../components/ForgotPassword";
import Login from "../components/Login";
import LoginSSO from "../components/LoginSSO";
import Registration from "../components/Registration";
import ResetPassword from "../components/ResetPassword";

const App = () => {
  return (
    <Switch>
      <Route exact path={Router.login_path()} component={Login} />
      <Route exact path={Router.login_sso_path()} component={LoginSSO} />
      <Route exact path={Router.new_user_session_path()} component={Login} />
      <Route
        exact
        path={Router.forgot_password_path()}
        component={ForgotPassword}
      />
      <Route
        exact
        path={Router.user_account_setup_path()}
        component={Registration}
      />
      <Route
        exact
        path={Router.reset_password_path()}
        component={ResetPassword}
      />
      <Route component={Login} />
    </Switch>
  );
};

export default App;
